import { Box } from '@tanium/react-box';
import { TaniumSpinner } from '@tanium/react-tanium-spinner';

export const FullPageSpinner: React.VFC = () => (
  <Box height="100vh">
    <TaniumSpinner />
  </Box>
);
